class CartRemoveButton extends HTMLElement {
  constructor() {
    super()
    // this.drawer = this
    this.umgGwp = window.UmgGwp
    this.cartUI = document.querySelector('cart-drawer') || document.querySelector('cart-items')
    // if (document.querySelector('cart-items')) {
    //   this.cartUI = this.cartUI.closest('.shopify-section')
    // }

    this.addEventListener('click', (e) => {
      e.preventDefault()
      if (this.getAttribute('disabled')) {
        return
      }
      (this.closest('cart-items') || this.closest('cart-drawer-items')).updateQuantity(this.dataset.index, 0)
    })
  }
}

customElements.get('cart-remove-button') || customElements.define('cart-remove-button', CartRemoveButton)

class CartItems extends HTMLElement {
  constructor() {
    super();
    
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || 
                                document.getElementById('CartDrawer-LineItemStatus')

    if (document.querySelector('.cart-shipping')) {
      this.minSpend = document.querySelector('.cart-shipping').dataset.minSpend;
      this.minTotal = Math.round(this.minSpend * (Shopify.currency.rate || 1))
      this.cartShipping()
    }
    this.umgGwp = window.UmgGwp
    this.cartUI = document.querySelector('cart-drawer') || document.querySelector('cart-items')
    this.umgGwp = window.UmgGwp

    const debouncedOnChange = debounce((event) => {
      this.onChange(event)
    }, ON_CHANGE_DEBOUNCE_TIMER)

    this.addEventListener('change', debouncedOnChange.bind(this))
    if (this.umgGwp !== undefined) {
      let sections = 'cart-drawer,cart-icon-bubble'
      const sections_url = window.location.pathname

      if (!document.querySelector('cart-drawer')) {
        const id = this.cartUI.closest('.shopify-section').id
        const sectionId = id.split('shopify-section-').pop()
        sections = sectionId + ',cart-icon-bubble'
      }
      setTimeout(() => {
        debounce(UmgGwp(this.cartUI, sections, sections_url),
        ON_CHANGE_DEBOUNCE_TIMER) })
    }
  }

  cartUpdateUnsubscriber = undefined;

  cartShipping() {
    this.total = document.querySelector('.cart-shipping').dataset.total
    this.progress = (this.total / this.minTotal) * 100
    
    if (this.progress > 100) {
      this.progress = 100
    }

    let element
    if (this.minTotal > this.total) {
      const remaining = this.minTotal - this.total
      const message = document.querySelector('.cart-shipping').dataset.message.replace('||amount||', formatMoney(remaining))
      document.querySelector('.cart-shipping__message_default').innerText = message
      document.querySelector('.cart-shipping__message_success').classList.remove('active')
      element = document.querySelector('.cart-shipping__message_default')
    } else {
      document.querySelector('.cart-shipping__message_default').classList.remove('active')
      element = document.querySelector('.cart-shipping__message_success')
    }
    element.classList.add('active')
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source !== 'cart-items') {
        this.onCartUpdate()
      }
    })
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber()
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    )
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((text) => {
        const domContainer = this.querySelector('.js-contents')
        if (!domContainer) return
        const html = new DOMParser().parseFromString(text, 'text/html')
        const resContent = html.querySelector('.js-contents')
        domContainer.replaceWith(resContent)
        this.classList.toggle('is-empty', resContent.innerHTML === '')
      })
      .catch((error) => {
        console.error(error)
      })
  }

  onCartUpdateDrawer() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html')
        const cartItems = html.querySelector('cart-drawer-items')
        this.innerHTML = cartItems.innerHTML
      })
      .catch((error) => {
        console.error(error)
      })
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents-totals'
      },
      {
        id: 'main-cart-shipping',
        section: document.getElementById('main-cart-shipping').dataset.id || null,
        selector: '.js-contents-shipping'
      }
    ]
  }

  updateQuantity(lineItemIndex, quantity, name) {
    const cartPage = document.querySelector('.template-cart')

    this.enableLoading(lineItemIndex - 1)

    this.querySelectorAll('.quantity__button').forEach((button) => {
      button.classList.add('disabled')
    });

    if (document.querySelectorAll('.card--product card__add-to-cart button[name="add"]')) {
      document.querySelectorAll('.card--product .card__add-to-cart button[name="add"]')
        .forEach((button) => {
          button.setAttribute('aria-disabled', false);
          if (button.querySelector('span')) {
            button.querySelector('span').classList.remove('hidden')
            if (button.querySelector('.sold-out-message')) {
              button.querySelector('.sold-out-message').classList.add('hidden')
            }
          }
        })
    }

    const body = JSON.stringify({
      line: lineItemIndex,
      quantity: quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    })

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body })
      .then((response) => response.text())
      .then((responseText) => {
        const parsedState = JSON.parse(responseText);
        const quantityElement = document.getElementById(`Quantity-${lineItemIndex}`) || 
                               document.getElementById(`Drawer-quantity-${lineItemIndex}`)
        const cartItems = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value')
          this.updateLiveRegions(lineItemIndex, parsedState.errors)

          this.querySelectorAll('.quantity__button').forEach((button) => {
            button.classList.remove('disabled')
          })
          if (this.querySelector(`#CartDrawer-Item-${lineItemIndex} .quantity__button-plus`)) {
            this.querySelector(`#CartDrawer-Item-${lineItemIndex} .quantity__button-plus`).classList.add('disabled')
          }

        } else {
          this.classList.toggle('is-empty', parsedState.item_count === 0)

          const cartDrawer = document.querySelector('cart-drawer')
          const cartFooter = document.getElementById('main-cart-footer')
          
          if (cartFooter) {
            cartFooter.classList.toggle('is-empty', parsedState.item_count === 0)
          }

          if (cartDrawer) {
            cartDrawer.classList.toggle('is-empty', parsedState.item_count === 0)
          }

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || 
                                   document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector)
          })

          const lineItemQuantity = parsedState.items[lineItemIndex - 1] ? parsedState.items[lineItemIndex - 1].quantity : undefined

          let message = ''
          if ((cartItems) && (lineItemQuantity)) {
            if (cartItems.length === parsedState.items.length && lineItemQuantity !== parseInt(quantityElement.value)) {
              if (typeof lineItemQuantity === 'undefined') {
                message = window.cartStrings.error
              } else {
                message = window.cartStrings.quantityError.replace('[quantity]', lineItemQuantity)
              }
            }
          }

          this.updateLiveRegions(lineItemIndex, message)

          const lineItem = document.getElementById(`CartItem-${lineItemIndex}`) || 
                          document.getElementById(`CartDrawer-Item-${lineItemIndex}`)

          if (!cartPage) {
            if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
              if (cartDrawer) {
                trapFocus(cartDrawer, lineItem.querySelector(`[name="${name}"]`))
              } else {
                lineItem.querySelector(`[name="${name}"]`).focus()
              }
            } else if (parsedState.item_count === 0 && cartDrawer) {
              trapFocus(cartDrawer.querySelector('.drawer__inner-empty'), cartDrawer.querySelector('a'))
            } else if (document.querySelector('.cart-item') && cartDrawer) {
              trapFocus(cartDrawer, document.querySelector('.cart-item__name'))
            }
          }                

          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' })
        }
      })
      .catch((error) => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => {
          overlay.classList.add('hidden');
        })
        
        this.querySelectorAll('quantity-input').forEach((button) => {
          button.checkPurchaseLimit()
        })

        const errors = document.getElementById('cart-errors') || 
                      document.getElementById('CartDrawer-CartErrors')
        if (errors) {
          errors.textContent = window.cartStrings.error
        }
      })
      .finally(() => {
        this.querySelectorAll('quantity-input').forEach((button) => {
          button.checkPurchaseLimit()
        });

        if (document.querySelector('.cart-shipping')) {
          this.cartShipping()
        }

        if (document.querySelector('add-all')){
          document.querySelectorAll('add-all').forEach(addAll => {
            addAll.checkCartItems()
          })
        }

        // subtract 1 to account for data-index="{{ item.index | plus: 1 }}" 
        this.disableLoading(lineItemIndex - 1);
      });
  }

  renderContents(response) {
    Object.keys(response.sections).forEach(key => {
      const value = response.sections[key];

      var serverObject = document.createElement('div')
      serverObject.innerHTML = value;
      serverObject.replaceWith(value);
      const itemId = serverObject.querySelector('.shopify-section').id
      const original = document.getElementById(itemId)
      original.replaceWith(serverObject.querySelector('.shopify-section'))
    });

    if (document.querySelector('add-all')){
      document.querySelectorAll('add-all').forEach(addAll => {
        addAll.checkCartItems()
      })
    }
  }

  isJson (item) {
    let value = typeof item !== 'string' ? JSON.stringify(item) : item
    try {
      value = JSON.parse(value)
    } catch (e) {
      return false
    }
    return typeof value === 'object' && value !== null
  }

  updateLiveRegions(lineItemIndex, message) {
    const lineItemError = document.getElementById(`Line-item-error-${lineItemIndex}`) || 
                         document.getElementById(`CartDrawer-LineItemError-${lineItemIndex}`)

    // check if message is JSON - parse JSON
    // check if message is an Array
    // if none, then it is very likely a string
    const parsed = message && (this.isJson(message) ? 
      Array.isArray(JSON.parse(message)) ? 
        JSON.parse(message)[0] : JSON.parse(message) :
      Array.isArray(message) ?
        message[0] : message
    )

    if (lineItemError) {
      lineItemError.style.display = 'flex'
      const errorText = lineItemError.querySelector('.cart-item__error-text');
      if (parsed && errorText) {
        if(typeof parsed == 'object') {
          if (parsed.variants && parsed.variants.length > 0) {
            const variantsFiltered = parsed.variants.filter(variant => {
              return parseInt(variant.lineId,10) == parseInt(lineItemIndex-1,10)
            })
            errorText.innerHTML = variantsFiltered.length > 0 && variantsFiltered[0].error
          }
          if (errorText.innerHTML == '' && parsed.error && parsed.error != '') {
            errorText.innerHTML = parsed.error
          }
        } else if (typeof parsed == 'string') {
          errorText.innerHTML = parsed
        }
      }
      if (errorText.innerHTML) {
        errorText.style.padding = '0.6rem'
      }
    }

    this.lineItemStatusElement.setAttribute('aria-hidden', true)

    const cartStatus = document.getElementById('cart-live-region-text') || 
                      document.getElementById('CartDrawer-LiveRegionText')
                      
    cartStatus.setAttribute('aria-hidden', false)

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true)
    }, 1000)
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)
      .innerHTML;
  }

  enableLoading(lineItemIndex) {
    const cartItems = document.getElementById('main-cart-items')
    if (cartItems) {
      cartItems.classList.add('cart__items--disabled')
      this.querySelectorAll(`#CartItem-${lineItemIndex} .loading-overlay`).forEach((overlay) => {
        overlay.classList.remove('hidden')
      });
      document.activeElement.blur()
      this.lineItemStatusElement.setAttribute('aria-hidden', false)
    }
  }

  disableLoading(lineItemIndex) {
    const cartItems = document.getElementById('main-cart-items')
    if (cartItems) {
      cartItems.classList.remove('cart__items--disabled')
      this.querySelectorAll(`#CartItem-${lineItemIndex} .loading-overlay`).forEach((overlay) => {
        overlay.classList.add('hidden')
      })
    }
  }
}

customElements.get('cart-items') || customElements.define('cart-items', CartItems)

customElements.get('cart-note') || customElements.define('cart-note', 
  class extends HTMLElement {
    constructor() {
      super()
      this.addEventListener('change', 
        debounce((event) => {
          const body = JSON.stringify({ 
            note: event.target.value 
          });
          fetch(`${routes.cart_update_url}`, {
            ...fetchConfig(),
            body
          });
        }, ON_CHANGE_DEBOUNCE_TIMER)
      )
    }
  }
)

class CartDrawer extends HTMLElement {
  constructor() {
    super()
    this.header = document.querySelector('.header-wrapper')
    
    if (this.header) {
      this.header.preventHide = false
    }

    this.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') {
        this.close();
      }
    })

    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this))
    this.setHeaderCartIconAccessibility()
  }

  setHeaderCartIconAccessibility() {
    const cartIcon = document.querySelector('#cart-icon-bubble')
    cartIcon.setAttribute('role', 'button')
    cartIcon.setAttribute('aria-haspopup', 'dialog')

    cartIcon.addEventListener('click', (event) => {
      event.preventDefault()
      this.open(cartIcon)
    })

    cartIcon.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault()
        this.open(cartIcon)
      }
    })
  }

  open(opener) {
    if (this.header) {
      this.header.preventHide = true
    }

    if (opener) {
      this.setActiveElement(opener)
    }

    const summaryElement = this.querySelector('[id^="Details-"] summary')
    if (summaryElement && !summaryElement.hasAttribute('role')) {
      this.setSummaryAccessibility(summaryElement)
    }

    setTimeout(() => {
      this.classList.add('animate', 'active')
    })

    this.addEventListener('transitionend', () => {
      const container = this.classList.contains('is-empty') 
        ? this.querySelector('.drawer__empty')
        : document.getElementById('CartDrawer')
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close')
      trapFocus(container, focusElement);
    }, { once: true });

    document.querySelector('#MainContent').classList.add('overflow-hidden-drawer')
    document.querySelector('.shopify-section-group-footer-group').classList.add('overflow-hidden-drawer')
  }

  close() {
    this.classList.remove('active')
    removeTrapFocus(this.activeElement)
    document.querySelector('#MainContent').classList.remove('overflow-hidden-drawer')
    document.querySelector('.shopify-section-group-footer-group').classList.add('overflow-hidden-drawer')
    
    if (this.header) {
      this.header.preventHide = false
    }
  }

  setSummaryAccessibility(element) {
    element.setAttribute('role', 'button')
    element.setAttribute('aria-expanded', 'false')

    if (element.nextElementSibling.getAttribute('id')) {
      element.setAttribute('aria-controls', element.nextElementSibling.id)
    }

    element.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      )
    })

    element.parentElement.addEventListener('keyup', onKeyUpEscape)
  }

  renderContents(response) {
    this.productId = response.id;

    this.getSectionsToRender().forEach((section) => {
      const element = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id)
      element.innerHTML = this.getSectionInnerHTML(response.sections[section.id], section.selector)
    })

    if (document.querySelector('add-all')){
      document.querySelectorAll('add-all').forEach(addAll => {
        addAll.checkCartItems()
      })
    }

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this, false));
      this.open()
    })
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)
      .innerHTML
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble' }
    ]
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)
  }

  setActiveElement(element) {
    this.activeElement = element
  }
}

customElements.get('cart-drawer') || customElements.define('cart-drawer', CartDrawer)

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ]
  }

  enableLoading() {
    const footer = document.querySelector('.cart-drawer__footer')
    if (footer) {
      footer.querySelector('.totals__subtotal-value > span').classList.add('disabled')
      const overlay = footer.querySelector('.loading-overlay')
      if (overlay) {
        overlay.classList.remove('hidden')
      }
      document.activeElement.blur()
    }
  }

  disableLoading() {
    const footer = document.querySelector('.cart-drawer__footer')
    if (footer) {
      footer.querySelector('.totals__subtotal-value > span').classList.remove('disabled')
      const overlay = footer.querySelector('.loading-overlay')
      if (overlay) {
        overlay.classList.add('hidden')
      }
    }
  }
}

customElements.get('cart-drawer-items') || customElements.define('cart-drawer-items', CartDrawerItems)

setTimeout($(document).on('click', '.update_qty_to_purchase_limit', function () {
  var purchase_limit = $(this).attr('purchase_limit');
  var item_id = $(this).attr('item_id');
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      'quantity': purchase_limit,
      'id': item_id
    },
    dataType: 'json',
    success: function (response) {
      location.reload()
    },
    error: function (error) {
      console.error('Cart update failed:', error);
    }
  });
}),1500);

setTimeout($(document).on('click', '.update_qty_to_purchase_limit_drawer', function () {
  var purchase_limit = $(this).attr('purchase_limit');
  var item_id = $(this).attr('item_id');
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      'quantity': purchase_limit,
      'id': item_id
    },
    dataType: 'json',
    success: function (response) {
      $.get('/cart', function(data) {
        var cartContent = $(data).find('.cart-drawer__footer').html();
        var cartheading = $(data).find('.drawer__heading').html();
        var cartCount = $(data).find('.cart-count-bubble span:first-child').html(); 
        $('.cart-drawer__footer').html(cartContent);
        $('.drawer__heading').html(cartheading);
        $('.cart-count-bubble span:first-child').html(cartCount);
      });

      const cartItemsElement = document.querySelector('cart-drawer-items');
      if (cartItemsElement) {
        let lineItemIndex = null;
        const cartItems = cartItemsElement.querySelectorAll('.drawer__cart-items');

        cartItems.forEach((item, index) => {
          const itemIdInCart = item.dataset.variantId || item.dataset.id || item.querySelector('.variant_id')?.value; 
          if (itemIdInCart == item_id) {
            lineItemIndex = index + 1;
            return; 
          }
        });

        if (lineItemIndex!== null) {
          const updatedQuantity = response.quantity || purchase_limit; 
          cartItemsElement.updateQuantity(lineItemIndex, updatedQuantity);
        } else {
          cartItemsElement.onCartUpdateDrawer(); 
        }
      } else {
        cartItemsElement.onCartUpdateDrawer();
      }
    },
    error: function (error) {
      console.error('Cart drawer update failed:', error);
    }
  });
}),1500);
